




























import Component from "vue-class-component";
import Vue from "vue";
import {FieldState} from "../../../../types";
import FieldDataTableDeck from "./FieldDataTableDeck.vue";
import GameAddCardsFrom from "../../TableHand/GameAddCardsFrom.vue";
import EventApi from "../../../api/EventsApi";

@Component({
    components: {GameAddCardsFrom, FieldDataTableDeck},
    props: {
        field: {
            required: true,
            type: Object,
        },
    }
})

export default class EditField extends Vue {
    private field!: FieldState;
    private files: FileList|null = null;
    private showForm: boolean = false;
    private selectedDecks: Array<string> = [];

    mounted(): void
    {
        EventApi.addEventListener('select_card_in_admin_table', this.selectCard.bind(this));
        EventApi.addEventListener('deselect_card_in_admin_table', this.deselectCard.bind(this));
    }

    beforeDestroy(): void
    {
        EventApi.removeEventListener('select_card_in_admin_table', this.selectCard.bind(this));
        EventApi.removeEventListener('deselect_card_in_admin_table', this.deselectCard.bind(this));
    }

    private selectCard(e: any): void
    {
        this.selectedDecks.push(e.detail);
    }

    private deselectCard(e: any): void
    {
        this.selectedDecks = this.selectedDecks.filter(deckId => {
            return deckId !== e.detail;
        });
    }

    private showUploadFilesForm(files: FileList): void
    {
        this.files = files;
        this.showForm = true;
    }

    private hideUploadFilesForm(): void
    {
        this.files = null;
        this.showForm = false;
    }
}
